export default [{
  path: '/journal',
  name: 'journal',
  meta: {
    layout: 'main'
  },
  component: () => import('@/views/journal/index')
}]
